import {
  FaUserCircle,
  FaHome,
  FaDice,
  FaHistory,
  FaWallet,
  FaQuestionCircle,
  FaUserFriends,
  FaEnvelope,
  FaUser,
  FaSignOutAlt,
  FaTrophy,
} from "react-icons/fa";

import { FaGlobe } from "react-icons/fa";
import { parseJWT } from "../../utils/jwtUtils";

const ResponsiveMenu = ({ showMenu }) => {
  const menuItems = [
    {
      icon: <FaDice />,
      label: "Bingo Game",
      href: "/",
    },
    { icon: <FaWallet />, label: "Wallet", href: "/wallet" },
    { icon: <FaHistory />, label: "Game History", href: "/history" },
    {
      icon: <FaQuestionCircle />,
      label: "How to Win",
      href: "/HowToWin",
    },
    {
      icon: <FaTrophy className="text-yellow-400" />,
      label: "Leaderboard",
      href: "/leaderboard",
    },
    {
      icon: <FaUserFriends />,
      label: "Referral Income",
      href: "/referralIncome",
    },
  ];

  const userItems = [
    { icon: <FaUser />, label: "Profile", href: "/profile" },
    {
      icon: <FaEnvelope />,
      label: "Contact_Us",
      href: "https://t.me/bingo",
    },
    { icon: <FaSignOutAlt />, label: "Log out", href: "/logout" },
  ];
  const handleLogout = () => {
    localStorage.removeItem("userInfo");

    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.close();
    } else {
      window.location.href = "/";
    }
  };

  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
  const userInfo = parseJWT(token?.token);

  return (
    <div
      className={`${
        showMenu ? "left-0" : "-left-[100%]"
      } fixed bottom-0 top-0 z-20 flex h-screen w-[75%] flex-col justify-between bg-gradient-to-b from-cyan-950 via-cyan-800 to-cyan-950 px-6 pb-6 pt-32 text-white transition-all duration-300 md:hidden`}
    >
      <div>
        {/* User Info */}
        <div className="flex items-center gap-3 mb-4">
          <FaUserCircle size={50} className="text-blue-500" />
          <div>
            <h1 className="font-semibold text-lg font-serif">
              {userInfo?.username}
            </h1>
            <h2 className="text-sm text-slate-400 font-serif">
              {userInfo?.phone}
            </h2>
          </div>
        </div>

        {/* Main Navigation */}
        <nav>
          <ul className="flex flex-col gap-1">
            {" "}
            {/* Reduced gap here */}
            <hr className="my-2 border-t border-slate-500" />
            {menuItems.map((item, idx) => (
              <li key={idx}>
                <a
                  href={item.href}
                  className="font-serif flex items-center gap-2 py-1 px-3 rounded-lg hover:bg-blue-600/30 transition-colors duration-200"
                >
                  {item.icon}
                  <span className="font-medium font-serif">{item.label}</span>
                </a>
              </li>
            ))}
            <hr className="my-2 border-t border-slate-500" />
            {userItems.map((item, idx) => (
              <li key={idx}>
                {item.label === "Log out" ? (
                  <button
                    onClick={handleLogout}
                    className="font-serif flex items-center gap-2 py-2 px-3 w-full text-left rounded-lg hover:bg-red-600/30 transition-colors duration-200"
                  >
                    {item.icon}
                    <span className="font-medium">{item.label}</span>
                  </button>
                ) : (
                  <a
                    href={item.href}
                    className="flex items-center gap-2 py-2 px-3 rounded-lg hover:bg-red-600/30 transition-colors duration-200"
                  >
                    {item.icon}
                    <span className="font-medium">{item.label}</span>
                  </a>
                )}
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default ResponsiveMenu;
